module.exports = __webpack_public_path__ + "static/img/yongsan-development-future-city-seoul.f6c74ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/yongsan-development-future-city-seoul.jpg
// module id = Zc80
// module chunks = 0